import { useTranslation } from "@/hooks/useTranslation"
import { FilterOutlined } from "@/icons"
import { RESOURCES } from "."
import { RadioGroupSectionFormTemplate } from "../RadioGroupSectionFormTemplate"

import type { ResourcesSectionFormProps } from "."

const sectionId = "resources-section-form"

export const ResourcesSectionForm = (props: ResourcesSectionFormProps) => {
  const {
    form,
    children,
    disabled,
    title,
    info,
    fieldName = "resources",
    keyPrefix = "forms.sections.resources",
    Icon = FilterOutlined
  } = props
  const { t } = useTranslation("translation", { keyPrefix })
  const { ALL, SPECIFIC } = RESOURCES

  return (
    <RadioGroupSectionFormTemplate
      disabled={disabled}
      form={form}
      fieldName={fieldName}
      title={title || t("title")}
      sectionId={sectionId}
      info={info}
      Icon={Icon}
      items={[
        { label: t(ALL), value: ALL },
        {
          children,
          label: t(SPECIFIC),
          value: SPECIFIC,
          content: props.popoverContent
        }
      ]}
    />
  )
}

ResourcesSectionForm.sectionId = sectionId
